import { toast } from "sonner";
import api, { callRefreshToken } from "../config/http-common";
import axios from "axios";


export const getloggedCompanySubscription = async () => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/subscription/me");
};

export const getSubscriptionLimit = async (featureCode) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(`/subscription/${featureCode}/limit`);
};

export const invoiceList = async (paging) => {
  const { pageNumber, pageSize } = paging;
  let url = `/invoices?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const downloadInvoice = async (
  invoiceId, invoiceNumber, error
) => {
  try {
    let api = `/invoices/${invoiceId}/download`;

    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + api,
      {
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
          timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;


    link.setAttribute("download", `${invoiceNumber}.pdf`);
    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
  } catch (e) {
    console.error("Error downloading the file", e);
    toast.error(error);
  }
};

export const cancelSubscription = async (subscriptionId, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post(`/subscription/${subscriptionId}/cancel`, payload);
};
export const getPlanAndFeature = async () => {
  const value = await callRefreshToken();
  if (value == true)
    return api.securedAxios().get(`/plans-features`);
};

export const pauseSubscription = async (subscriptionId) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post(`/subscription/${subscriptionId}/autoPayment?autoPayment=false`);
};

export const contactSales = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post(`/subscriptions/contact`, payload);
};

export const resumeSubscription = async (subscriptionId) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post(`/subscription/${subscriptionId}/autoPayment?autoPayment=true`);
};

export const updateCardSubscription = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put('/subscriptions/card', payload);
};

export const getCardDetails = async (customerId) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(`/cards/${customerId}`);
};

export const checkControlPanelUser = async (email) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(process.env.REACT_APP_SERVER_URL?.replace("/api/v1", "/web") + `/control_panel/${email}/user`);
};

export const downloadInvoiceMuliple = async (
  invoiceIds, e
) => {
  try {
    let api = `/invoices/download`;
    const value = await callRefreshToken();
    if (value == true) {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + api,
        invoiceIds,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `invoices.zip`);
      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
    }

  } catch (error) {
    console.error("Error downloading the file", error);
    toast.error(e);
  }
};

export const createSubscription = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post(`/subscriptions/hostedpage`, payload);
};

export const upgradeSubscription = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put(`/subscriptions/hostedpage`, payload);
};

export const paymentProcess = async (id) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put(`/subscriptions/hostedpage/${id}`);
};

export const archivePlan = async (planOrder) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put(process.env.REACT_APP_SERVER_URL?.replace("/api/v1", "/web") + `/plans/${planOrder}/archive`);
}; 

export const updateCustomerDetails = async (customerId, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put("/customers/" + customerId, payload);
};

export const getCustomerDetails = async (customerId) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/customers/" + customerId);
};